import { render, staticRenderFns } from "./AdjustConfigForm.vue?vue&type=template&id=5b63ccfe&scoped=true"
import script from "./AdjustConfigForm.vue?vue&type=script&lang=js"
export * from "./AdjustConfigForm.vue?vue&type=script&lang=js"
import style0 from "./AdjustConfigForm.vue?vue&type=style&index=0&id=5b63ccfe&prod&lang=less&scoped=true"
import style1 from "./AdjustConfigForm.vue?vue&type=style&index=1&id=5b63ccfe&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b63ccfe",
  null
  
)

export default component.exports